/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import AsideMenu from './AsideMenu'
import Footer from './Footer'
import HorizontalMenu from './HorizontalMenu'
import { getAuth, onAuthStateChanged } from "firebase/auth";


import { useAppSelector, useAppDispatch } from '../../config/hooks'
import { setUser } from '../../config/userSlice'
import { Timestamp, doc, getDoc, where } from "firebase/firestore";

import { myFirestore } from '../../config/MyFirebase';
import { collection, query, DocumentData, getDocs, onSnapshot, orderBy } from 'firebase/firestore';
import Home from '../users/Home'
import { getMessaging, onMessage } from "firebase/messaging";
import { onBackgroundMessage } from "firebase/messaging/sw";
import MyNotification from '../MyNotification'
import { toast } from 'react-toastify'


export default function Template() {

    // const [userId, setUserId] = useState('');
    // const [user, setUser] = useState({});

    const [activeDateMessage, setActiveDateMessage] = useState<string>('');
    const [dateMessages, setDateMessages] = useState<any[]>([]);
    const [messages, setMessages] = useState<any[]>([]);
    const [myUserId, setMyUserId] = useState<string>('');

    const user = useAppSelector((state) => state.user.user)

    const dispatch = useAppDispatch()



    const messaging = getMessaging();
    // onMessage(messaging, (payload) => {
    //     console.log('Template Message received. ', payload);
    //     // ...
    // });

    // onBackgroundMessage(messaging, (payload) => {
    //     console.log('Template Received background message ', payload);
    //     // Customize notification here
    //     const notificationTitle = 'Background Message Title';
    //     const notificationOptions = {
    //         body: 'Background Message body.',
    //         icon: '/firebase-logo.png'
    //     };

    //     // self.registration.showNotification(notificationTitle,
    //     //   notificationOptions);
    // });

    //Get user data from auth
    const getAndSetUserToRedux = () => {

        const auth = getAuth();
        onAuthStateChanged(auth, async (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/auth.user
                const uid = user.uid;
                setMyUserId(uid)

                //Get user data with her id to charge user data to redux
                const docRef = doc(myFirestore, "users", uid);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {

                    console.log("Document data:", docSnap.data());
                    dispatch(setUser(docSnap.data()));

                    //Get List of dateMessages for user Id
                    getDateMessages(uid);


                } else {
                    // docSnap.data() will be undefined in this case
                    console.log("No such document!");
                }
                // ...
            } else {
                // User is signed out
                // ...
            }
        });

    }

    const formatDate = (date: Date): string => {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Les mois commencent à 0
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const getDateMessages = (userId: string) => {

        console.log("here: ", userId);

        let lastDateMessage: DocumentData;


        var now = new Date();
        const maxMessageDuration = user.max_message_duration;
        const dateTimeMinusJs = new Date(now.getTime() - (maxMessageDuration * 60000));
        const dateTimeMinus = Timestamp.fromDate(dateTimeMinusJs);
        const q = query(collection(myFirestore, "users", userId, "date_messages"), orderBy('timestamps', 'desc'));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            let dateMessages: any[] = [];

            let i = 0; // To catch the last date_message at the first turn of the forEach
            if (querySnapshot.size > 0)
                querySnapshot.forEach((doc) => {

                    dateMessages.push(doc.data());
                    if (i == 0) {
                        lastDateMessage = doc.data();
                    }
                    i++;

                });

            setDateMessages(dateMessages);
            if (querySnapshot.size > 0) {

                getMessagesOf(userId, lastDateMessage);
                setActiveDateMessage(lastDateMessage.date)

            }

        });

    }

    const getMessagesOf = (userId: string, dateMessage: DocumentData) => {
        console.log("je viens de chez l'enfant");
        console.log("gmUserid: ", userId, " gmdmId: ", dateMessage);

        if (dateMessage) {
            var now = new Date();

            const maxMessageDuration = user.max_message_duration;
            const dateTimeMinusJs = new Date(now.getTime() - (maxMessageDuration * 60000));
            const dateTimeMinus = Timestamp.fromDate(dateTimeMinusJs);

            const q = query(collection(myFirestore, "users", userId, "date_messages", dateMessage.id, "messages"), where('timestamps', ">=", dateTimeMinus), orderBy("timestamps"));
            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                let themessages: any[] = [];
                querySnapshot.forEach((doc) => {
                    console.log(doc.data());
                    themessages.push(doc.data());
                });
                setMessages(themessages);
                setActiveDateMessage(formatDate(dateMessage.timestamps.toDate()))
            });
        }

    }


    // const clickToday = async () => {
    //     //check if dateMessage for today exist
    //     let today = format(new Date(), "M/d/yyyy");
    //     // Create a query against the collection.
    //     const dateMessagesQuery = collection(myFirestore, "users", userId, "date_messages");
    //     const q = query(dateMessagesQuery, where("date", "==", today));

    //     const querySnapshot = await getDocs(q);

    //     let date_message_id = '';

    //     if (querySnapshot.size > 0) {
    //         //If date_message_id already exist
    //         //If the date_messages for today already exist
    //         //Return her id
    //         querySnapshot.forEach((doc) => {
    //             date_message_id = doc.id;
    //         });


    //     } else {
    //         //if date_message_id not already exist
    //         let new_id_date_message = generateRandomId(10, uuidv4());
    //         let now = Timestamp.fromDate(new Date());
    //         let formattedNow = format(today, "M/d/yyyy");

    //         // Add a new document in collection "date_messages"
    //         await setDoc(doc(myFirestore, "users", userId, "date_messages", new_id_date_message), {
    //             "id": new_id_date_message,
    //             "date": formattedNow,
    //             "last_message_time": null,
    //             "last_message_type": null,
    //             "last_message": null,
    //             "count_messages": 0,
    //             "user_id": userId,
    //             "timestamps": now,
    //         }).then(() => date_message_id = new_id_date_message);

    //     }
    // }



    useEffect(() => {

        //Get and set user data from auth to redux
        //Also launch getDateMessages
        // toast(<MyNotification image={""} title={"Login success"} body={"Welcome"} />);

        getAndSetUserToRedux();

    }, [])

    return (
        <div className='wrapper'>
            <HorizontalMenu />
            <AsideMenu userId={myUserId} getMessageOf={getMessagesOf} dateMessages={dateMessages} />

            {/* <div className="preloader flex-column justify-content-center align-items-center">
                <img className="animation__shake" src="dist/img/AdminLTELogo.png" alt="AdminLTELogo" height="60" width="60" />
            </div> */}



            {/* <!-- Content Wrapper. Contains page content --> */}
            {/* <Outlet /> */}
            <Home userId={myUserId} activeDateMessage={activeDateMessage} messages={messages} />




            <aside className="control-sidebar control-sidebar-dark">
            </aside>
            <Footer />
        </div>

    )
}
